exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-form-field {\n  width: 100%; }\n\n.loading-circle {\n  position: absolute !important;\n  top: 5px !important;\n  right: 10px !important; }\n\n::ng-deep .loading-circle circle {\n  stroke: blue !important;\n  background-color: #ffffff; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/permissions-selector/permissions-selector.component.scss
// module id = ../../../../../src/app/shared/components/permissions-selector/permissions-selector.component.scss
// module chunks = main